import React, { forwardRef, TouchEvent, useState } from "react";
import CloseSvg from "../../assets/taiga-uikit/icons/close.svg?react";
import { _size, _sizeHeading, _style } from "../../core/core";
import { Button } from "../button/button";
import Title from "../texts/title";
import "./Modal.css";

interface ModalBaseProps {
  title?: string;
  image_url?: string | null;
  width?: string;
  active?: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
  button_width?: string;
  button_style?: _style;
  button_text?: string;
  button_size?: _size;
  onClose?: () => void;
  children?: React.ReactNode;
}

export const ModalBase = forwardRef<HTMLElement, ModalBaseProps>(
  (
    {
      title = "",
      width = "auto",
      active = false,
      setActive,
      button_width = "",
      button_style = _style.primary,
      button_text = "",
      button_size = _size.S,
      onClose,
      children,
    },
    ref
  ) => {
    const [startY, setStartY] = useState<number | null>(null);

    const handleTouchStart = (event: TouchEvent<HTMLDivElement>): void => {
      setStartY(event.touches[0].clientY);
    };

    const handleTouchMove = (event: TouchEvent<HTMLDivElement>): void => {
      if (startY !== null) {
        const currentY = event.touches[0].clientY;
        const deltaY = currentY - startY;

        if (deltaY > 100) {
          setActive(false);
        }
      }
    };

    const handleTouchEnd = (): void => {
      setStartY(null);
    };

    const handleClose = (): void => {
      setActive(false);
      if (onClose) onClose();
    };

    const getStyle = (): React.CSSProperties => {
      return { width };
    };

    const handleClickOpen = (e: React.MouseEvent): void => {
      setActive(true);
      e.stopPropagation();
    };

    return (
      <>
        {active ? (
          <div
            className="modal-main"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <div onClick={handleClose} className="modal-main-ground"></div>

            <div style={getStyle()} className="modal-main-card">
              <div className="modal-main-header">
                <Title type={_sizeHeading.h2_2}>{title}</Title>
                <Button onClick={handleClose} style={_style.clear2}>
                  <CloseSvg />
                </Button>
              </div>

              <div className="modal-main-body">{children}</div>
            </div>
          </div>
        ) : (
          <Button
            width={button_width}
            style={button_style}
            onClick={handleClickOpen}
            size={button_size}
          >
            {button_text}
          </Button>
        )}
      </>
    );
  }
);
